import { render, staticRenderFns } from "./Kbli.vue?vue&type=template&id=622b41c2&scoped=true"
import script from "./Kbli.vue?vue&type=script&lang=js"
export * from "./Kbli.vue?vue&type=script&lang=js"
import style0 from "./Kbli.vue?vue&type=style&index=0&id=622b41c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622b41c2",
  null
  
)

export default component.exports